import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const loginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);

  return (
    <loginContext.Provider
      value={{
        errorMessage,
        setErrorMessage,
        showError,
        setShowError
      }}>
      {children}
    </loginContext.Provider>
  );
};

LoginProvider.propTypes = {
  children: PropTypes.node
};

export const useLoginContext = () => useContext(loginContext);
